module.exports = __webpack_public_path__ + "0733936099454815d7dd86fc57e27c5c.glb";